import axios from '../config/axiosPrivate';

export const getHoldings = async (params: any = {}) => {
  const url = `/company/holdings`;
  const response = await axios.get(url, { params });
  return response.data;
};
